import { combineReducers } from "redux";
import Theme from "./Theme";
import Queries from "./Queries";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import Exact from "./Exact";

const reducers = combineReducers({
  firebaseReducer,
  firestoreReducer,
  theme: Theme,
  queries: Queries,
  exact: Exact,
});

export default reducers;
